/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddressView } from './AddressView';
import type { JtlOrderItemView } from './JtlOrderItemView';
import type { MoneyView } from './MoneyView';
export type JtlOrderView = {
    /**
     * Shop ID
     */
    shopId: string;
    /**
     * Shop type (e.g. jtl_shop_5, shopify_shop)
     */
    shopType: JtlOrderView.shopType;
    /**
     * Order ID
     */
    id: number;
    /**
     * Order number
     */
    orderNumber: string;
    orderDate?: string | null;
    isShipped?: boolean;
    totalPriceNet?: MoneyView | null;
    totalPriceGross?: MoneyView | null;
    /**
     * Order status (e.g. Offen, Versendet)
     */
    status?: string | null;
    /**
     * First product image URL
     */
    thumbnail?: string | null;
    items?: Array<JtlOrderItemView> | null;
    /**
     * Payment method name (e.g. Überweisung)
     */
    billingMethodName?: string | null;
    /**
     * Shipping method name (e.g. DHL Paket Inland)
     */
    shippingMethodName?: string | null;
    /**
     * Customer full name
     */
    customerName?: string | null;
    /**
     * Customer email
     */
    customerEmail?: string | null;
    /**
     * Billing address
     */
    billingAddress?: AddressView | null;
    /**
     * Shipping address
     */
    shippingAddress?: AddressView | null;
    /**
     * Order comment
     */
    comment?: string | null;
    /**
     * Tracking number/info
     */
    tracking?: string | null;
};
export namespace JtlOrderView {
    /**
     * Shop type (e.g. jtl_shop_5, shopify_shop)
     */
    export enum shopType {
        JTL_SHOP_5 = 'jtl_shop_5',
        JTL_WAWI_1_5 = 'jtl_wawi_1_5',
        JTL_WAWI_1_6 = 'jtl_wawi_1_6',
        EBAY_SHOP = 'ebay_shop',
        AMAZON_SHOP = 'amazon_shop',
        SHOPIFY_SHOP = 'shopify_shop',
    }
}

